import * as React from "react";
import { useAuthProvider } from "../middleware/AuthProvider";
import { AuthContext } from "src/components/context/AuthContext";
import { PropsWithChildren } from "react";

export const SecureProvider: React.FC<PropsWithChildren> = props => {
  const authProvider = useAuthProvider();
  return <AuthContext.Provider value={authProvider}>{props.children}</AuthContext.Provider>;
};
